import { render, staticRenderFns } from "./RetailerContactInformation.vue?vue&type=template&id=500a541f&lang=pug"
import script from "./RetailerContactInformation.vue?vue&type=script&lang=js"
export * from "./RetailerContactInformation.vue?vue&type=script&lang=js"
import style0 from "./RetailerContactInformation.vue?vue&type=style&index=0&id=500a541f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports